import { render, staticRenderFns } from "./updateUser.vue?vue&type=template&id=545bf0d6&scoped=true&"
import script from "./updateUser.vue?vue&type=script&lang=js&"
export * from "./updateUser.vue?vue&type=script&lang=js&"
import style0 from "./updateUser.vue?vue&type=style&index=0&id=545bf0d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545bf0d6",
  null
  
)

export default component.exports